var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base",attrs:{"id":"itemsWrapper"}},[_c('CursorCustom',{attrs:{"theme":_vm.theme}}),_c('BaseView',{attrs:{"theme":_vm.theme,"appear":_vm.appear,"animation":_vm.animation}},[_c('PageHistory')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }